<lib-breadcrumbs [path]="breadcrumbs" (segmentClicked)="breadcrumbClicked($event)"></lib-breadcrumbs>
